import { Injectable } from '@angular/core';

import { Observable, ReplaySubject } from 'rxjs';

import { Tab } from './tab';

@Injectable({
  providedIn: 'root'
})
export class TabService {
  activeTab: Tab;

  public readonly change: Observable<Tab>;

  private readonly changeSubject = new ReplaySubject<Tab>(1);
  private readonly savedPosition: Record<string, number> = {};
  private readonly registeredTabs = {};

  constructor() {
    this.change = this.changeSubject.asObservable();
  }

  setActive(tab: Tab): void {
    if (this.activeTab !== tab) {
      this.activeTab = tab;
      this.doChange();
    }
  }

  setActiveById(id: string): void {
    const toBeActivatedTab = this.registeredTabs[id];
    if (toBeActivatedTab) {
      this.setActive(toBeActivatedTab);
    }
  }

  getActive(): Tab {
    return this.activeTab;
  }

  refresh(): void {
    this.doChange();
  }

  register(tab: Tab): void {
    this.registeredTabs[tab.id] = tab;
  }

  savePosition(id: string, shift: number): void {
    this.savedPosition[id] = shift;
  }

  getSavedPosition(id: string): number {
    const pos = this.savedPosition[id];
    delete this.savedPosition[id];
    return pos;
  }

  private doChange(): void {
    this.changeSubject.next(this.activeTab);
  }
}
